"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dummyProducts = require("./dummyProducts");

var _dummyProducts2 = _interopRequireDefault(_dummyProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _dummyProducts2.default;